import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-secondary/30 border-t border-border mt-24">
      <div className="container mx-auto px-4 md:px-8 lg:px-12 max-w-7xl py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <img 
              src="https://aquaplantsplus.square.site/uploads/b/92824204f5eb3a1741c28b0b59a1630abf175e712898d2f2d5a8e8dc409472cf/AquaPlantsPlusLogo_1762231535.jpeg"
              alt="AquaPlants Plus Logo"
              className="h-16 w-auto object-contain mb-4"
            />
            <p className="text-sm text-muted-foreground">
              Missouri-grown live aquarium plants. Hobbyist-run. No fluff. Just freshwater stuff.
            </p>
          </div>

          {/* Shop */}
          <div>
            <h3 className="font-semibold mb-4">Shop</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/shop" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-shop">
                  All Products
                </Link>
              </li>
              <li>
                <Link to="/current-deals" className="text-muted-foreground hover:text-accent transition-colors" data-testid="footer-deals">
                  Current Deals
                </Link>
              </li>
              <li>
                <Link to="/tank-tailored-bundle" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-bundle">
                  Tank Tailored Bundle
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="font-semibold mb-4">Customer Service</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/shipping-policy" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-shipping">
                  Shipping & Returns
                </Link>
              </li>
              <li>
                <a href="mailto:contact.us@aquaplantsplus.com" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-contact">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold mb-4">Get in Touch</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
                <span className="text-muted-foreground">Springfield, Missouri</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
                <a href="mailto:contact.us@aquaplantsplus.com" className="text-muted-foreground hover:text-primary transition-colors">
                  contact.us@aquaplantsplus.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <svg className="w-4 h-4 mt-0.5 flex-shrink-0" fill="#1877F2" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
                <a href="https://www.facebook.com/profile.php?id=61574799224266" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors">
                  Follow us on Facebook
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border pt-8 text-center text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} AquaPlants Plus LLC. All rights reserved.</p>
          <p className="mt-2">We grow what we sell. Period.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
